/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import basicCaseInsuranceFields from "../modules/basicCaseInsuranceFields";
import { FamilyLawCase } from "../../../../types/Products/FamilyLaw/FamilyLawCase";

export const fullFormDefinition = (product: FamilyLawCase) => {
  return {
    processParticipants: {
      asAccordion: true,
      sections: [
        {
          label: "Versicherung",
          elements: [
            ...basicCaseInsuranceFields<FamilyLawCase>({
              path: `${product.productClassName}.caseInsurance`,
              product: product,
            }),
          ],
        },
      ],
    },
  };
};
